export const RECEIVE_MENU = 'RECEIVE_MENU';
export const SELECT_MENU = 'SELECT_MENU';
